// Direct upload
export const SUBMIT_CROPPED_FILE_PHOTO = 'SUBMIT_CROPPED_FILE_PHOTO';

// Shared
export const TOGGLE_REPLACE_PHOTO = 'TOGGLE_REPLACE_PHOTO';

// Instagram
export const AUTHENTICATE_INSTAGRAM = 'AUTHENTICATE_INSTAGRAM';
export const AUTHENTICATE_INSTAGRAM_FAILURE = 'AUTHENTICATE_INSTAGRAM_FAILURE';
export const AUTHENTICATE_INSTAGRAM_SUCCESS = 'AUTHENTICATE_INSTAGRAM_SUCCESS';
export const CONNECT_INSTAGRAM = 'CONNECT_INSTAGRAM';
export const CONNECT_INSTAGRAM_FAILURE = 'CONNECT_INSTAGRAM_FAILURE';
export const CONNECT_INSTAGRAM_SUCCESS = 'CONNECT_INSTAGRAM_SUCCESS';
export const DISCONNECT_INSTAGRAM = 'DISCONNECT_INSTAGRAM';
export const DISCONNECT_INSTAGRAM_FAILURE = 'DISCONNECT_INSTAGRAM_FAILURE';
export const DISCONNECT_INSTAGRAM_SUCCESS = 'DISCONNECT_INSTAGRAM_SUCCESS';
export const FETCH_INSTAGRAM_OAUTH_URL = 'FETCH_INSTAGRAM_OAUTH_URL';
export const FETCH_INSTAGRAM_OAUTH_URL_SUCCESS = 'FETCH_INSTAGRAM_OAUTH_URL_SUCCESS';
export const PROMPT_DISCONNECT_INSTAGRAM = 'PROMPT_DISCONNECT_INSTAGRAM';
